import { ChangeDetectionStrategy, Component, EventEmitter, Input, NgModule, OnDestroy, Output, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest, map, Observable, tap } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ObservableInput, ReduxModule } from '../../../../utils/util.redux';
import { DateUtility } from '@jms/model';
import { LuxonCalendarModule } from '@workbuddy/ui/fields/luxon.calendar';
import { StateComponent } from '@jms/utils/util.state.component';
import { DateTime } from 'luxon';

interface DayPickerComponentVM {
  date: DateTime;
  dateFormat: string;
  timezone: string;
}

enum MoveType {
  Back = 'Back',
  Forward = 'Forward',
  Today = 'Today',
  ToDate = 'To Date'
}

const initialState = {
  date: DateUtility.getDateTime(new Date()),
  dateFormat: 'dd/MM/yyyy',
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
}

@UntilDestroy()
@Component({
    selector: 'day-picker',
    templateUrl: './day.picker.component.html',
    styleUrls: ['./day.picker.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DayPickerComponent extends StateComponent<DayPickerComponentVM> {

  @ObservableInput() @Input('date') public date$: Observable<DateTime>;
  @ObservableInput() @Input('dateFormat') public dateFormat$: Observable<string>;
  @ObservableInput() @Input('timezone') public timezone$: Observable<string>;

  @Output() public change = new EventEmitter<DateTime>();

  public selectedDate = new FormControl();
  public MoveType = MoveType;

  public styleIconCalendar = {
    'background': 'transparent',
    'color': '#111',
    'font-size': '12px',
    'border': 'none'
  };

  constructor() {

    super(initialState);

    this.styleIconCalendar = {
      'background': 'transparent',
      'color': '#111',
      'font-size': '12px',
      'border': 'none'
    };



    combineLatest([
      this.date$,
      this.timezone$,
      this.dateFormat$
    ])
      .pipe(
        map(([date, timezone, dateFormat]) => {

          if (!date)
            return;

          this.setStateDirect({
            date: date,
            timezone: timezone,
            dateFormat: dateFormat
          });

        })
      ).subscribe()

    this.selectedDate.valueChanges
      .pipe(
        untilDestroyed(this),
        tap(x => {

          const date = DateUtility.getDateTime(new Date(x));
          this.change.emit(date)
        })
      ).subscribe();

  }

  public onChangeDate(type: MoveType) {

    const currentDay = DateUtility.getDateTime(this.vm.date);

    switch (type) {
      case MoveType.Back: {
        const previousDay = currentDay.minus({ day: 1 });
        this.change.emit(previousDay);
        break;
      }
      case MoveType.Forward: {
        const nextDay = currentDay.plus({ day: 1 });
        this.change.emit(nextDay);
        break;
      }
      case MoveType.Today: {

        const today = DateUtility.getNowAsUtcWithCurrentTime();
        this.change.emit(today);
        break;
      }
    }

  }


}

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ReduxModule,
    ReactiveFormsModule,
    LuxonCalendarModule
  ],
  declarations: [
    DayPickerComponent
  ],
  providers: [],
  exports: [
    DayPickerComponent
  ],
})
export class DayPickerModule { }
